import React from "react";
import { Box } from "@mui/system";
import { TextareaAutosize } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { QuestionFooter } from "./QuestionFooter";

export function FreeTextComponent({
  initialValues, question, addAnswer, previous, next,loadingAnswer
}) {
  const { handleChange, handleSubmit, values, isValid, errors } = useFormik({
    initialValues: {
      user_id: "",
      questionId: question.id,
      answerText: initialValues?.answerText ?? "",
    },
    onSubmit: async (values) => {
      const proceed = await addAnswer(question.id, [values]);
      if(proceed){ // false if answer is not added to the backend
        next();
      }
    },
    validationSchema: Yup.object().shape({
      answerText: Yup.string()
        .required("Frage ist erforderlich")
        .max(500),
    }),
  });
  return (
    <div className="survey-choice">
      <div className="survey-number-answer">Deine Antwort:</div>
      <TextareaAutosize
        maxRows={4}
        aria-label="maximum height"
        name="answerText"
        onChange={handleChange}
        color="#238CB9"
        value={values.answerText}
        style={{
          border: "none",
          outline: "none",
          borderRadius: "14px",
          boxShadow: "0px 3px 6px #00000029",
          backgroundColor: "#ffffff",
          overflow: "hidden",
          padding: "24px",
          display: "flex",
          fontSize: "16px",
          color: "#238CB9",
          fontFamily: "'Rubik', sans-serif",
        }} />
      <QuestionFooter showErrorModal={errors?.answerText ? errors?.answerText : ''} back={previous} onSave={handleSubmit} isValid={isValid} isSubmitting={loadingAnswer} />
    </div>
  );
}
